// Recovered compiled webpack factory 20821. Edit this function expression; run npm run build.
(e, t) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      VALID_LOADERS: function () {
        return r;
      },
      imageConfigDefault: function () {
        return n;
      },
    }));
  let r = ["default", "imgix", "cloudinary", "akamai", "custom"],
    n = {
      deviceSizes: [640, 750, 828, 1080, 1200, 1920, 2048, 3840],
      imageSizes: [16, 32, 48, 64, 96, 128, 256, 384],
      path: "/_next/image",
      loader: "default",
      loaderFile: "",
      domains: [],
      disableStaticImages: !1,
      minimumCacheTTL: 60,
      formats: ["image/webp"],
      maximumDiskCacheSize: void 0,
      maximumResponseBody: 5e7,
      dangerouslyAllowSVG: !1,
      contentSecurityPolicy: "script-src 'none'; frame-src 'none'; sandbox;",
      contentDispositionType: "attachment",
      localPatterns: void 0,
      remotePatterns: [],
      qualities: void 0,
      unoptimized: !1,
    };
}
